import { Capacitor, registerPlugin, type PluginListenerHandle } from "@capacitor/core";

export type NativeTimerStatus = "idle" | "running" | "complete";

export type NativeTimerState = {
  status: NativeTimerStatus;
  targetEpochMs: number | null;
  originalDurationSeconds: number;
  workoutId: string | null;
  setId: string | null;
  exerciseName: string | null;
  workoutTitle: string | null;
  workoutActive: boolean;
  nextExerciseName: string | null;
  nextSetNumber: number;
  nextSetDetails: string | null;
};

export type NativePermissionStatus = {
  notifications: boolean;
  exactAlarms: boolean;
};

type GymNativePlugin = {
  setAuthToken(options: { token: string }): Promise<void>;
  getAuthToken(): Promise<{ token: string | null }>;
  clearAuthToken(): Promise<void>;
  getAppInfo(): Promise<{ versionName: string; versionCode: number }>;
  getPermissionStatus(): Promise<NativePermissionStatus>;
  requestNotificationPermission(): Promise<NativePermissionStatus>;
  openExactAlarmSettings(): Promise<void>;
  getRestTimerState(): Promise<NativeTimerState>;
  syncActiveWorkout(options: {
    workoutId: string;
    workoutTitle: string;
    nextExerciseName: string | null;
    nextSetNumber: number;
    nextSetDetails: string | null;
  }): Promise<NativeTimerState>;
  clearActiveWorkout(): Promise<NativeTimerState>;
  startRestTimer(options: {
    durationSeconds: number;
    workoutId: string;
    setId: string;
    exerciseName: string;
    workoutTitle: string;
    setNumber: number;
    nextExerciseName: string | null;
    nextSetNumber: number;
    nextSetDetails: string | null;
  }): Promise<NativeTimerState>;
  adjustRestTimer(options: { deltaSeconds: number }): Promise<NativeTimerState>;
  cancelRestTimer(): Promise<NativeTimerState>;
  addListener(eventName: "restTimerChanged", listener: (state: NativeTimerState) => void): Promise<PluginListenerHandle>;
};

export const isNativeAndroid = Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";
export const GymNative = registerPlugin<GymNativePlugin>("GymNative");

export async function nativeAuthToken(): Promise<string | null> {
  if (!isNativeAndroid) return null;
  return (await GymNative.getAuthToken()).token;
}
